import { useEffect, useMemo } from 'react';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { selectUserDetails, selectIsMultiStoreEnabled } from '../redux/UserReducer/userSlice';
import { getEffectiveStoreNumber } from '../utils/appUtils';
import { fetchLocalLiftMaxData } from '../redux/PerformanceReducer/LocalLift/localLiftMaxSlice';
import { RADRequest } from '../models/common/RADRequest';

export const useLocalLiftMaxData = () => {
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector(selectUserDetails);
  const isMultiStoreEnabled = useAppSelector(selectIsMultiStoreEnabled);

  const effectiveStoreNumber = useMemo(
    () => getEffectiveStoreNumber(userDetails, isMultiStoreEnabled),
    [userDetails, isMultiStoreEnabled]
  );

  useEffect(() => {
    if (!effectiveStoreNumber) {
      return;
    }

    const request: RADRequest = {
      storeNumber: effectiveStoreNumber,
      isMultiStoreMode: isMultiStoreEnabled,
    };

    dispatch(fetchLocalLiftMaxData(request));
  }, [dispatch, effectiveStoreNumber, isMultiStoreEnabled]);

  // This hook does not return any value
  return undefined;
};
